import { MatSnackBar } from '@angular/material/snack-bar';
import { DisplayService } from './../../core/services/display.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-display-create',
  templateUrl: './display-create.component.html',
  styleUrls: ['./display-create.component.scss']
})
export class DisplayCreateComponent implements OnInit {

  public display = {
    nummer: '',
    description: '',
    content: '',
    price: 0,
    rabatt: false,
    breite: null,
    hoehe: null,
    tiefe: null,
    zusatzinhalte: '',
    rabatt_hoehe: 0,
    bild: '',
  }

  constructor(private displayService: DisplayService, private snack: MatSnackBar) { }

  ngOnInit(): void {
  }

  choosedImage(event) {
    let imgFile = event.target.files[0];
    if(!imgFile)
      return;
    const reader = new FileReader();
    reader.readAsDataURL(imgFile);
    reader.onload = () => {
        this.display.bild = reader.result as string;
        event.target.value = null;
    };
  }

  public saving = false;
  public errors = [];
  save() {
    this.errors = [];
    this.saving = true;
    this.displayService.store(sessionStorage.getItem("anbieterNummer"), this.display).subscribe(res => {
      this.saving = false;
      this.snack.open('Display wurde erfolgreich erstellt', '', {panelClass: 'success-snackbar'});
    }, err => {
      console.log(err);
      this.saving = false;
      if(err.status == 400) {
        Object.values(err.error.errors).map(e => this.errors.push(e['defaultMessage']));
      } else if(err.status == 990) {
        this.errors.push('Bitte geben Sie die Rabatt-Höhe an');
      }
    });
  }
}
